import TopHeader from "components/common/header";
import { Check, Expand } from "components/common/Icons";
import { DiagnosticDetailSkeleton } from "components/skeleton/detail";
import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "next-i18next";
import { TYPO } from "styles/Typo";
import { useParams } from "next/navigation";
import DetailDiagnosisGlobalTab from "./GlobalTab";
import Link from "next/link";

function DiagnosisTemplete({
  tickerName,
  category,
  children,
  isLoading,
  data,
  bgColor,
  isMobile,
  ticker,
}: {
  tickerName: string;
  children: React.ReactNode;
  isLoading: boolean;
  data: Record<string, any>;
  category?: {
    name: string;
    date: string;
    description: string;
    score: number;
  };
  bgColor?: string;
  isMobile?: boolean;
  ticker: string;
}) {
  const router = useRouter();
  const [selectModal, setSelectModal] = useState(false);
  const tooltipRef = useRef<HTMLDivElement>(null);
  const selectBoxRef = useRef<HTMLDivElement>(null);

  // 외부 클릭 감지
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        tooltipRef.current &&
        !tooltipRef.current.contains(event.target) &&
        selectBoxRef.current &&
        !selectBoxRef.current.contains(event.target)
      ) {
        setSelectModal(false); // 외부 클릭시 툴팁 숨기기
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // 헤더 보이기 여부
  // const [isHeaderVisible, setIsHeaderVisible] = useState(true);
  // const [lastScrollY, setLastScrollY] = useState(0);
  // useEffect(() => {
  //   const handleScroll = () => {
  //     const currentScrollY = window.scrollY;

  //     // 스크롤 방향 감지
  //     const scrollingUp = currentScrollY < lastScrollY;

  //     if (currentScrollY <= 50) {
  //       // 0~30px 구간: 항상 보임
  //       setIsHeaderVisible(true);
  //     } else if (scrollingUp) {
  //       // 30px 이상이지만 위로 스크롤하고 있으면: 보임
  //       setIsHeaderVisible(true);
  //     } else {
  //       // 30px 이상에서 아래로 스크롤하고 있으면: 숨김
  //       setIsHeaderVisible(false);
  //     }

  //     setLastScrollY(currentScrollY);
  //   };

  //   // throttle을 위한 requestAnimationFrame 사용
  //   let ticking = false;
  //   const throttledHandleScroll = () => {
  //     if (!ticking) {
  //       requestAnimationFrame(() => {
  //         handleScroll();
  //         ticking = false;
  //       });
  //       ticking = true;
  //     }
  //   };

  //   window.addEventListener("scroll", throttledHandleScroll);

  //   return () => {
  //     window.removeEventListener("scroll", throttledHandleScroll);
  //   };
  // }, [lastScrollY]);

  return (
    <main
      className={`min-w-[360px] w-screen max-w-[800px] ${
        bgColor ? bgColor : "bg-gray2"
      } relative`}
    >
      {isLoading && (
        <div className="h-screen">
          <DiagnosticDetailSkeleton />
        </div>
      )}
      {!isLoading && (!data || Object.keys(data)?.length === 0) && (
        <>
          <TopHeader
            title={tickerName}
            clickHandler={() => {
              router.back();
            }}
            bgColor=""
          />
          <div
            className={`${TYPO.TYPO5_MD} w-full h-screen flex justify-center items-center`}
          >
            데이터가 없어요.
          </div>
        </>
      )}
      {!isLoading && data && (
        <div className="pb-9 bg-white">
          <div
            className="sticky z-[30]  transition-transform duration-300 bg-white  "
            style={{
              top: isMobile ? "0px" : "64px",
              // transform: isHeaderVisible
              //   ? "translateY(0)"
              //   : "translateY(-56px)",
            }}
          >
            <TopHeader
              title={tickerName}
              clickHandler={() => {
                router.back();
              }}
              bgColor=""
            />
            {/* {!isMobile ? (
              <TopHeader
                title={tickerName}
                clickHandler={() => {
                  router.back();
                }}
                bgColor=""
              />
            ) : (
              <div className="px-5 py-4">
                <Link
                  href="/"
                  onClick={(e) => {
                    window.dataLayer.push({
                      event: "ClickDetailHeaderLogo",
                    });
                    e.preventDefault();
                    sessionStorage.removeItem(`main-scrollPosition`);
                    sessionStorage.removeItem(`search-scrollPosition`);
                    window.location.href = `/${router.locale}`;
                  }}
                  className="block"
                >
                  <img
                    width={30}
                    height={30}
                    src={`/images/header/headerLogo.svg`}
                    alt="logo"
                    className="cursor-pointer w-auto h-auto"
                  />
                </Link>
              </div>
            )} */}

            {/* <DetailDiagnosisGlobalTab /> */}
          </div>

          {/* <div className="flex flex-col gap-1 px-6 pt-[30px]">
            <span className={`text-gray80 ${TYPO.TYPO5_1_SB}`}>
              {category?.description ? category?.description : ""}
            </span>
            <span className={`${TYPO.TYPO7_RG} text-gray50`}>
              {category?.date} 기준
            </span>
          </div> */}
          {children}
        </div>
      )}
    </main>
  );
}

export default DiagnosisTemplete;
